import React, {Fragment, useEffect} from 'react';
import {Link, useParams} from "react-router-dom";
import {useApi} from "../../../providers/ApiProvider";
import {useBreadcrumbs} from "../../../providers/BreadcrumbsProvider";
import BusinessesModel from "../../../models/BusinessesModel";
import BusinessViewHeader from "../BusinessViewHeader";
import SimpleCardContainer from "../../ui/SimpleCardContainer";
import Chart from "react-apexcharts";
import BusinessViewMenu from "../BusinessViewMenu";
import BusinessesInsightsChart from "./BusinessesInsightsChart";
import {useTranslation} from "react-i18next";
import {useTranslation as useMyTranslation} from "../../../providers/TranslationProvider";
// import { PDFDownloadLink, Page, Text, View, Document, StyleSheet } from '@react-pdf/renderer';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import StrHelper from "../../../helpers/StrHelper";
import {useAuth} from "../../../providers/AuthProvider";
import UsersModel from "../../../models/UsersModel";

function BusinessesInsights(props) {

    const authContext = useAuth();
    const user = authContext.user;
    const defaultDateStart 		= (new Date(Date.now() - (30 + 3) * 24 * 60 * 60 * 1000)).toISOString().slice(0,10);
    const defaultDateEnd 		= (new Date(Date.now() - 3 * 24 * 60 * 60 * 1000)).toISOString().slice(0,10);	
	const defaultDateDiff 		= Math.round((new Date(defaultDateEnd).getTime() - new Date(defaultDateStart).getTime())/ (1000 * 3600 * 24));
	const defaultDateStartComp 	= new Date(Date.parse(defaultDateStart) - (defaultDateDiff * 24 * 60 * 60 * 1000)).toISOString().slice(0,10);
	const defaultDateEndComp 	= new Date(Date.parse(defaultDateStart)).toISOString().slice(0,10);	
    const {language} = useMyTranslation();
    const { t} = useTranslation();
    const params = useParams();
    const apiContext = useApi();	
    const [dateStart, setDateStart] = React.useState(defaultDateStart);
    const [dateEnd, setDateEnd] = React.useState(defaultDateEnd);	
    const [dateStartComp, setDateStartComp] = React.useState(defaultDateStartComp);
    const [dateEndComp, setDateEndComp] = React.useState(defaultDateEndComp);	
    const businessesModel = new BusinessesModel(apiContext.api);
    const userModel = new UsersModel(apiContext.api);
    const breadcrumbs = useBreadcrumbs();
    const [insights, setInsights] = React.useState({});	
    const [insightsComp, setInsightsComp] = React.useState({});
	const [reviews, setReviews] = React.useState([]);
      const [seoAudit, setSeoAudit] = React.useState(null);
      const [competitors, setCompetitors] = React.useState([]);
      const [competitorsAnalysis, setCompetitorsAnalysis] = React.useState(null);
    const [insightsSearchKeywords, setInsightsSearchKeywords] = React.useState({});
	const [metricValuesImp, setMetricValuesImp] = React.useState([]);
    const [metricLabelSelected, setMetricLabelSelected] = React.useState('Total');
	const [loading, setLoading] = React.useState(true);
      const [loadingInsights, setLoadingInsights] = React.useState(true);
      const [loadingKeywords, setLoadingKeywords] = React.useState(true);
      const [loadingReviews, setLoadingReviews] = React.useState(true);
      const [loadingSeo, setLoadingSeo] = React.useState(true);
      const [loadingCompetitors, setLoadingCompetitors] = React.useState(true);
      const [loadingAnalysis, setLoadingAnalysis] = React.useState(true);
      const [loadingCompare, setLoadingCompare] = React.useState(true);
      const allDataLoaded = !loadingInsights && !loadingKeywords && !loadingReviews && !loadingSeo && !loadingCompetitors && !loadingAnalysis && !loadingCompare;	
	const [businessName, setBusinessName] = React.useState('');
	const [compare, setCompare] = React.useState(false);	
    const [compareMode, setCompareMode] = React.useState('previous_period');
    const onProfileRefresh = (profile, lastUpdated) => {
        return true;
    }
    
	const metricLabels = {
        'Total': t('All Business interactions'),
        'BUSINESS_DIRECTION_REQUESTS': t('Directions'),
        // 'BUSINESS_IMPRESSIONS_DESKTOP_MAPS': t('Desktop Maps Impressions'),
		// 'BUSINESS_IMPRESSIONS_DESKTOP_SEARCH': t('Desktop Search Impressions'),
        // 'BUSINESS_IMPRESSIONS_MOBILE_MAPS': t('Mobile Maps Impressions'),
        // 'BUSINESS_IMPRESSIONS_MOBILE_SEARCH': t('Mobile Search Impressions'),
        'CALL_CLICKS': t('Calls'),
        'WEBSITE_CLICKS': t('Website Clicks'),
    };

    const metricLabelsImp = {
		
        'BUSINESS_IMPRESSIONS_MOBILE_SEARCH': t('Google Search – mobile'),
		'BUSINESS_IMPRESSIONS_DESKTOP_SEARCH': t('Google Search – desktop'),
        'BUSINESS_IMPRESSIONS_MOBILE_MAPS': t('Google Maps – mobile'),
		'BUSINESS_IMPRESSIONS_DESKTOP_MAPS': t('Google Maps – desktop'), 
    };

	const getInsights = () => {
	 
		setLoading(true);
          setLoadingInsights(true);
          setLoadingKeywords(true);
          setLoadingReviews(true);
          setLoadingSeo(true);
          setLoadingCompetitors(true);
          setLoadingAnalysis(true);
          setLoadingCompare(true);		
				
		const diff = Math.round((new Date(dateEnd).getTime() - new Date(dateStart).getTime())/ (1000 * 3600 * 24));
		
		if (compareMode === 'previous_month') {
			const compStart = new Date(dateStart);
			compStart.setMonth(compStart.getMonth() - 1);
			const compEnd = new Date(dateEnd);
			compEnd.setMonth(compEnd.getMonth() - 1);
			setDateStartComp(compStart.toISOString().slice(0,10));
			setDateEndComp(compEnd.toISOString().slice(0,10));
		} else if (compareMode === 'previous_year') {
			const compStart = new Date(dateStart);
			compStart.setFullYear(compStart.getFullYear() - 1);
			const compEnd = new Date(dateEnd);
			compEnd.setFullYear(compEnd.getFullYear() - 1);
			setDateStartComp(compStart.toISOString().slice(0,10));
			setDateEndComp(compEnd.toISOString().slice(0,10));
		} else {
			setDateStartComp(new Date(Date.parse(dateStart) - (diff * 24 * 60 * 60 * 1000)).toISOString().slice(0,10));
			setDateEndComp(new Date(Date.parse(dateStart)).toISOString().slice(0,10));
		}
        
		businessesModel.insights(params.locationId, dateStart, dateEnd).then((response) => {
            if (response !== false) {
                setInsights(response);
            }
        }).finally(() => setLoadingInsights(false));

		businessesModel.ightsSearchKeywords(params.locationId, dateStart, dateEnd).then((response) => {
            if (response !== false) {
                setInsightsSearchKeywords(response);
            }
        }).finally(() => setLoadingKeywords(false));
		
        businessesModel.getReviews(params.locationId).then((response) => {
            if (response !== false) {
				
				let reviewsArr = [];
                response.map((review, index) => {
					let starRatingNumeric = 0;
					if (review) {
						switch (review.starRating) {
							case 'ONE'	: starRatingNumeric = 1; break;
							case 'TWO'	: starRatingNumeric = 2; break;
							case 'THREE': starRatingNumeric = 3; break;
							case 'FOUR'	: starRatingNumeric = 4; break;
							case 'FIVE'	: starRatingNumeric = 5; break;
						}
					}
					review.rating = starRatingNumeric; 
					reviewsArr[index] = review;
                });
				
                setReviews(reviewsArr.sort((a,b) => (b.rating > a.rating) ? 1 : ((a.rating > b.rating) ? -1 : 0)));
            }
        }).finally(() => setLoadingReviews(false));
		

  		businessesModel.getSavedSeoAudit(params.locationId).then((response) => {
  			if (response !== false) {
  				setSeoAudit(response);
  			}
  		}).finally(() => setLoadingSeo(false));

  		businessesModel.listCompetitors(params.locationId).then((response) => {
  			if (response !== false) {
  				setCompetitors(response);
  			}
  		}).finally(() => setLoadingCompetitors(false));


		businessesModel.analyzeCompetitors(params.locationId).then((response) => {
			if (response !== false) {
				if (response.parsed && response.analysis) {
					setCompetitorsAnalysis(response.analysis);
				} else if (response.raw) {
					try { setCompetitorsAnalysis(JSON.parse(response.raw)); } catch(e) { setCompetitorsAnalysis({ summary: response.raw }); }
				}
			}
		}).finally(() => setLoadingAnalysis(false));
		compareInsights();
    }
	
	const compareInsights = () => {		
		
        businessesModel.insights(params.locationId, dateStartComp, dateEndComp).then((response) => {
            if (response !== false) {
                setInsightsComp(response);
            }
        }).finally(() => {
            setLoadingCompare(false);
            setLoading(false);

            setTimeout(checkAutomatedPrinting, 2000);
        });	
	}

    
    useEffect(() => {
        async function init() {

            businessesModel.view(params.locationId).then((response) => {
                if (response !== false) {
                    breadcrumbs.update({
                        title: response.data.title,
                        breadcrumbs: [
                            {label: t('Businesses List'), url: '/businesses'},
                            {label: response.data.title, url: '/businesses/' + params.locationId},
                            {label: t('Insights')}
                        ]
                    });

                    document.title = t('Insights') + ' | ' + response.data.title + ' | LocalBoost';
                    setBusinessName(response.data.title);
                }
            }).finally(() => {
                getInsights();
                setCompare(false);
            });

            setDateStart(defaultDateStart);
            setDateEnd(defaultDateEnd);
        }

        init();
    }, [language]);


    const checkAutomatedPrinting = () => {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has('print')) {
            html2canvas(document.getElementById("insightsWrap"), {

                onclone: function (clonedDoc) {
                    // clonedDoc.getElementById('businessesReviews').style.display = 'block';
                    let gap = clonedDoc.querySelector('.m-block-gap');
                    if (gap) { gap.style.marginBottom = "15px"; }

                    let cards = clonedDoc.querySelectorAll('.card');
                    for (let index = 0; index < cards.length; index++) {
                        cards[index].style.border = "1px solid #c7ccd0";
                        cards[index].style.borderRadius = "7px";
                    }
                },
                scale: 3,

            }).then(canvas => {
                var imgData 	= canvas.toDataURL("PNG", 1.0);

                document.body.innerHTML = '';
                var img = new Image();
                img.src = imgData;
                document.body.appendChild(img);
                img.style.width = '100%';
                img.style.height = 'auto';

                // add padding 3% to body
                document.body.style.padding = '3%';

            });
        }
    }


    useEffect(() => {
        getInsights();
		
    }, [dateStart, dateEnd, compareMode]);
	
    useEffect(() => {
        compareInsights();
		
    }, [dateStartComp, dateEndComp]);
	
    const getMetricSummary = (metricLabel, past=false) => {
	
		let data = past ? insightsComp : insights;
        let value = 0;
        if (data[metricLabel]) {
            Object.values(data[metricLabel]).forEach((item) => {
                value += parseInt(item);
				});
        } else if (metricLabel === 'Total') {
            ['BUSINESS_DIRECTION_REQUESTS', 'CALL_CLICKS', 'WEBSITE_CLICKS'].forEach((item) => {
                if (data[item]) {
                    Object.values(data[item]).forEach((item) => {
                        value += parseInt(item);
                    });
                }
            });
        }

        return value;
    }
	
	useEffect(() => {
	
		let obj = [];
		
		Object.entries(metricLabelsImp).forEach(([key, value]) => {	

			obj.push(getMetricSummary(key));
		});

        setMetricValuesImp(obj);
    }, [insights]);
	
	const [donutOptions, setDonutOptions] = React.useState({
		
		series: Object.values(metricValuesImp),
		labels: Object.values(metricLabelsImp),
        chart: {
            type: "donut",
            fontFamily: '"Plus Jakarta Sans", "Open Sans", Arial, sans-serif',
			
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '80%'                    
                },
			},
        },
        dataLabels: {
            enabled: false,
        },
        stroke: {
            show: false,
        },
        legend: {
            show: true,
			itemMargin: {
				horizontal: 5,
				vertical: 5
			},
			showForNullSeries: true,
			fontSize: '14px',
			formatter: function(seriesName, opts, impessionTotal) {
				
				let tot = opts.w.globals.series.reduce((a, b) => a + b, 0);
				let val = opts.w.globals.series[opts.seriesIndex];
				let pct = tot > 0 ? Math.round((val/tot)*100) : 0;
				return [
				
					'<b style="width:70px;display:inline-block;">',	val,' · ',pct,'%','</b>','',seriesName,			
				]
			},	
        },
		colors: ['#f29900', '#1a73e8', '#d93025', '#1e8e3e'],
        tooltip: {
            theme: "dark",
            fillSeriesColor: false,
        },
    });	
	
	const printDocument = async () => {
  	
  		setLoading(true);
  		
  		const pdf = new jsPDF('p', 'mm', 'a4', true);
  		const pageWidth = pdf.internal.pageSize.getWidth();
  		const pageHeight = pdf.internal.pageSize.getHeight();
  		const margin = 10;
  		const usableWidth = pageWidth - (margin * 2);
  		const usablePageHeight = pageHeight - 20;
  		
  		const insightsWrap = document.getElementById('insightsWrap');
  		const page2El = document.getElementById('reportPage2');
  		
  		if (page2El) {
  			page2El.style.display = 'none';
  		}
  		
  		try {
  			const canvas1 = await html2canvas(insightsWrap, {
  				onclone: function (clonedDoc) {
  					let gap = clonedDoc.querySelector('.m-block-gap');
  					if (gap) { gap.style.marginBottom = "15px"; }
  					let cards = clonedDoc.querySelectorAll('.card');
  					for (let i = 0; i < cards.length; i++) {
  						cards[i].style.border = "1px solid #e0e0e0";
  						cards[i].style.borderRadius = "12px";
  						cards[i].style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
  					}
  					let ignoreEls = clonedDoc.querySelectorAll('[data-html2canvas-ignore="true"]');
  					for (let el of ignoreEls) { el.style.display = 'none'; }
  					let p2 = clonedDoc.getElementById('reportPage2');
  					if (p2) { p2.style.display = 'none'; }
  				},
  				scale: 2,
  				useCORS: true,
  				allowTaint: true,
  			});
  			
  			const img1Width = usableWidth;
  			const img1Height = (canvas1.height * img1Width) / canvas1.width;
  			
  			if (img1Height <= usablePageHeight) {
  				pdf.addImage(canvas1.toDataURL("image/png", 1.0), "PNG", margin, margin, img1Width, img1Height, '', 'FAST');
  			} else {
  				let hLeft = img1Height;
  				let srcY = 0;
  				let pNum = 0;
  				while (hLeft > 0) {
  					if (pNum > 0) { pdf.addPage(); }
  					const drawH = Math.min(usablePageHeight, hLeft);
  					const srcHPx = (drawH / img1Height) * canvas1.height;
  					const chunk = document.createElement('canvas');
  					chunk.width = canvas1.width;
  					chunk.height = srcHPx;
  					chunk.getContext('2d').drawImage(canvas1, 0, srcY, canvas1.width, srcHPx, 0, 0, canvas1.width, srcHPx);
  					pdf.addImage(chunk.toDataURL("image/png", 1.0), "PNG", margin, margin, img1Width, drawH, '', 'FAST');
  					hLeft -= drawH;
  					srcY += srcHPx;
  					pNum++;
  				}
  			}
  			
  			if (page2El) {
  				page2El.style.display = '';
  				
  				const canvas2 = await html2canvas(page2El, {
  					onclone: function (clonedDoc) {
  						let cards = clonedDoc.querySelectorAll('.card');
  						for (let i = 0; i < cards.length; i++) {
  							cards[i].style.border = "1px solid #e0e0e0";
  							cards[i].style.borderRadius = "12px";
  							cards[i].style.boxShadow = "0 2px 8px rgba(0,0,0,0.06)";
  						}
  					},
  					scale: 2,
  					useCORS: true,
  					allowTaint: true,
  				});
  				
  				const img2Width = usableWidth;
  				const img2Height = (canvas2.height * img2Width) / canvas2.width;
  				
  				pdf.addPage();
  				
  				if (img2Height <= usablePageHeight) {
  					pdf.addImage(canvas2.toDataURL("image/png", 1.0), "PNG", margin, margin, img2Width, img2Height, '', 'FAST');
  				} else {
  					let hLeft = img2Height;
  					let srcY = 0;
  					let pNum = 0;
  					while (hLeft > 0) {
  						if (pNum > 0) { pdf.addPage(); }
  						const drawH = Math.min(usablePageHeight, hLeft);
  						const srcHPx = (drawH / img2Height) * canvas2.height;
  						const chunk = document.createElement('canvas');
  						chunk.width = canvas2.width;
  						chunk.height = srcHPx;
  						chunk.getContext('2d').drawImage(canvas2, 0, srcY, canvas2.width, srcHPx, 0, 0, canvas2.width, srcHPx);
  						pdf.addImage(chunk.toDataURL("image/png", 1.0), "PNG", margin, margin, img2Width, drawH, '', 'FAST');
  						hLeft -= drawH;
  						srcY += srcHPx;
  						pNum++;
  					}
  				}
  			}
  			
  			pdf.save("LocalBoost_Report_" + (businessName || 'Business').replace(/\s+/g, '_') + "_" + dateStart + ".pdf");
  			
  		} catch(e) {
  			console.error('PDF generation error:', e);
  		} finally {
  			if (page2El) { page2El.style.display = ''; }
  			setLoading(false);
  		}
  		
  	};
	
		const formatDate =(date) =>{
	
		let monthNames = ["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
		let dt = new Date(date);
		return dt.getDate() + ' ' + monthNames[dt.getMonth()] + ' ' + dt.getFullYear();
	}
	
	const getMetricsDiff =(metricLabel) =>{
	
		let value = 0;
		let nowVal 	=	getMetricSummary(metricLabel);
		let pastVal =	getMetricSummary(metricLabel, true);
		
		if(pastVal == 0 && nowVal == 0){
		
			value = 0;
		}else if(pastVal > 0){
				
			value = Math.round(((nowVal - pastVal)/pastVal) * 10000)/100;
		}else{
			
			value = Math.round(((nowVal - 0.0001)/0.0001) * 10000)/100;
		}
        
		return value;
	}

    return (
          <>
              <div id="insightsWrap">
                  <div id="businessHeader">
                      <BusinessViewHeader
                          locationId={params.locationId}
                          onProfileRefresh={onProfileRefresh}
                      />
                  </div>
                  <div id="businessMenu" data-html2canvas-ignore="true">
                      <BusinessViewMenu locationId={params.locationId} active="insights" />
                  </div>
                  {insights && (
                  <>
                  <div className="row mb-3">
                      <div className="col-12">
                          <div className="card border-0 shadow-sm mb-0">
                              <div className="card-body py-3">
                                  <div className="d-flex flex-wrap align-items-center justify-content-between gap-3">
                                      <h5 className="fw-semibold mb-0">{t('Zeitraum')}</h5>
                                      <div className="d-flex flex-wrap align-items-center gap-2">
                                          <div className="d-flex align-items-center gap-2">
                                              <input type="date" className="form-control form-control-sm" defaultValue={dateStart} onChange={(e) => {setDateStart(e.target.value)}} style={{width: '150px'}} />
                                              <span className="text-muted">–</span>
                                              <input type="date" className="form-control form-control-sm" defaultValue={dateEnd} onChange={(e) => {setDateEnd(e.target.value)}} style={{width: '150px'}} />
                                          </div>
                                          <div className="d-flex align-items-center gap-2" data-html2canvas-ignore="true">
                                              <button className={"btn btn-sm " + (allDataLoaded ? "btn-primary" : "btn-secondary")} onClick={(e) => { if(allDataLoaded) printDocument(); }} disabled={!allDataLoaded} title={allDataLoaded ? t('All data loaded – report ready') : t('Data is loading...')}>
                                                    {!allDataLoaded && <span className="spinner-border spinner-border-sm me-1" role="status"></span>}
                                                    {allDataLoaded && <i className="ti ti-download me-1"></i>}
                                                    {allDataLoaded ? t('Download Report') : t('Data is loading...')}
                                                 </button>
                                          </div>
                                      </div>
                                  </div>
                                  <div className="d-flex flex-wrap align-items-center gap-2 mt-2">
                                      <select className="form-select form-select-sm" value={compareMode} onChange={(e) => setCompareMode(e.target.value)} style={{width: 'auto'}}>
                                          <option value="previous_period">{t('vs. Vorperiode')}</option>
                                          <option value="previous_month">{t('vs. Vormonat')}</option>
                                          <option value="previous_year">{t('vs. Vorjahr')}</option>
                                      </select>
                                      <span className="text-muted fs-2">{formatDate(dateStartComp)} – {formatDate(dateEndComp)}</span>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>

                  <div id="insightsCards" className="row mb-3">
                      {Object.entries(metricLabels).map(([key, label]) => {
                          const isSelected = metricLabelSelected === key;
                          const diff = getMetricsDiff(key);
                          const iconMap = {
                              'Total': 'ti-report-analytics',
                              'BUSINESS_DIRECTION_REQUESTS': 'ti-map-pin',
                              'CALL_CLICKS': 'ti-phone',
                              'WEBSITE_CLICKS': 'ti-world',
                          };
                          const colorMap = {
                              'Total': 'primary',
                              'BUSINESS_DIRECTION_REQUESTS': 'info',
                              'CALL_CLICKS': 'warning',
                              'WEBSITE_CLICKS': 'success',
                          };
                          const icon = iconMap[key] || 'ti-report-analytics';
                          const color = colorMap[key] || 'primary';

                          return (
                              <div className="col-sm-6 col-xl-3 mb-3" key={key}>
                                  <div
                                      className={'card border-0 shadow-sm h-100 mb-0 cursor-pointer' + (isSelected ? ' border-start border-4 border-' + color : '')}
                                      onClick={() => setMetricLabelSelected(key)}
                                      style={{cursor: 'pointer', borderLeft: isSelected ? '4px solid' : 'none'}}
                                  >
                                      <div className="card-body">
                                          <div className="d-flex align-items-center justify-content-between mb-3">
                                              <div className={'rounded-circle d-flex align-items-center justify-content-center bg-light-' + color} style={{width: '48px', height: '48px'}}>
                                                  <i className={'ti ' + icon + ' fs-6 text-' + color}></i>
                                              </div>
                                              {diff > 0 && (
                                                  <span className="text-success fs-2">
                                                      <i className="ti ti-trending-up me-1"></i>+{diff}%
                                                  </span>
                                              )}
                                              {diff < 0 && (
                                                  <span className="text-danger fs-2">
                                                      <i className="ti ti-trending-down me-1"></i>{diff}%
                                                  </span>
                                              )}
                                              {diff === 0 && (
                                                  <span className="text-muted fs-2">
                                                      <i className="ti ti-minus me-1"></i>0%
                                                  </span>
                                              )}
                                          </div>
                                          <h3 className="fw-semibold mb-1">{getMetricSummary(key).toLocaleString('de-DE')}</h3>
                                          <p className="text-muted mb-0 fs-3">{label}</p>
                                      </div>
                                  </div>
                              </div>
                          );
                      })}
                  </div>

                  <div id="insightsChart" className="row mb-3">
                      <div className="col-12">
                          <div className="card border-0 shadow-sm">
                              <div className="card-body">
                                  <div className="d-flex align-items-end justify-content-between mb-3">
                                      <div>
                                          <p className="text-muted mb-0 fs-3">{metricLabels[metricLabelSelected]}</p>
                                          <h4 className="fw-semibold mb-0">{getMetricSummary(metricLabelSelected).toLocaleString('de-DE')}</h4>
                                      </div>
                                  </div>
                                  <BusinessesInsightsChart insights={insights} metricLabel={metricLabelSelected} />
                              </div>
                          </div>
                      </div>
                  </div>
                  </>)}

                <div id="insightsImpressions" className="row mb-3">
                      <div className="col-lg-6 mb-3">
                          <div className="card border-0 shadow-sm h-100 mb-0">
                              <div className="px-4 py-3 border-bottom d-flex align-items-center justify-content-between">
                                  <h5 className="fw-semibold mb-0">
                                      <i className="ti ti-eye me-2 text-primary"></i>{t('Impressions')}
                                  </h5>
                                  <span className="fw-semibold fs-5 text-primary">{metricValuesImp.reduce((a, b) => a + b, 0).toLocaleString('de-DE')}</span>
                              </div>
                              <div className="card-body">
                                  <div className="row mb-3">
                                      {Object.entries(metricLabelsImp).map(([key, label], idx) => {
                                          const val = getMetricSummary(key);
                                          const total = metricValuesImp.reduce((a, b) => a + b, 0);
                                          const pct = total > 0 ? Math.round((val / total) * 100) : 0;
                                          const colors = ['warning', 'primary', 'danger', 'success'];
                                          const icons = ['ti-device-mobile', 'ti-device-desktop', 'ti-map-2', 'ti-map-pin'];
                                          const color = colors[idx] || 'primary';
                                          const icon = icons[idx] || 'ti-eye';
                                          return (
                                              <div className="col-6 mb-3" key={key}>
                                                  <div className={'rounded-3 p-3 bg-light-' + color}>
                                                      <div className="d-flex align-items-center mb-2">
                                                          <i className={'ti ' + icon + ' fs-5 text-' + color + ' me-2'}></i>
                                                          <span className="fs-2 text-muted">{label}</span>
                                                      </div>
                                                      <div className="d-flex align-items-end justify-content-between">
                                                          <h4 className={'fw-semibold mb-0 text-' + color}>{val.toLocaleString('de-DE')}</h4>
                                                          <span className="fs-2 text-muted fw-semibold">{pct}%</span>
                                                      </div>
                                                  </div>
                                              </div>
                                          );
                                      })}
                                  </div>
                                  <Chart type={'donut'} options={donutOptions} series={metricValuesImp} width={'100%'} height={180} />
                              </div>
                          </div>
                      </div>
                      {insightsSearchKeywords && Object.keys(insightsSearchKeywords).length > 0 && (
                      <div className="col-lg-6 mb-3">
                          <div className="card border-0 shadow-sm h-100 mb-0">
                              <div className="px-4 py-3 border-bottom d-flex align-items-center justify-content-between">
                                  <h5 className="fw-semibold mb-0">
                                      <i className="ti ti-search me-2 text-primary"></i>{t('Search Keywords')}
                                  </h5>
                                  <span className="badge bg-light-primary text-primary">{Object.keys(insightsSearchKeywords).length} {t('Begriffe')}</span>
                              </div>
                              <div className="card-body px-0">
                                  <div className="table-responsive">
                                      <table className="table table-hover align-middle mb-0">
                                          <tbody>
                                              {Object.entries(insightsSearchKeywords).map(([key, searchkeyword]) => (
                                                  <tr key={key}>
                                                      <td style={{width: '40px'}} className="text-center">
                                                          <span className={'badge rounded-circle bg-light-' + (parseInt(key) <= 3 ? 'primary' : 'secondary') + ' text-' + (parseInt(key) <= 3 ? 'primary' : 'secondary')} style={{width: '28px', height: '28px', lineHeight: '28px', padding: 0}}>
                                                              {key}
                                                          </span>
                                                      </td>
                                                      <td>
                                                          <span className="fw-semibold">{searchkeyword.title}</span>
                                                      </td>
                                                      <td className="text-end pe-4">
                                                          <span className="badge bg-light text-muted">{searchkeyword.threshold}</span>
                                                      </td>
                                                  </tr>
                                              ))}
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                      </div>
                      )}
                  </div>

                  <div className="row mb-3">
                      <div className="col-lg-4 mb-3">
                          <div className="card border-0 shadow-sm h-100 mb-0">
                              <div className="px-4 py-3 border-bottom">
                                  <h5 className="fw-semibold mb-0">
                                      <i className="ti ti-star me-2 text-warning"></i>{t('Durchschnittsbewertung')}
                                  </h5>
                              </div>
                              <div className="card-body text-center">
                                  {reviews.length > 0 ? (
                                      <>
                                          <h1 className="fw-bold text-warning mb-2" style={{fontSize: '3.5rem'}}>
                                              {(reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length).toFixed(1)}
                                          </h1>
                                          <div className="mb-2">
                                              {[1,2,3,4,5].map(star => (
                                                  <i key={star} className={'ti ti-star-filled fs-5 ' + (star <= Math.round(reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length) ? 'text-warning' : 'text-muted')} style={{opacity: star <= Math.round(reviews.reduce((sum, r) => sum + r.rating, 0) / reviews.length) ? 1 : 0.2}}></i>
                                              ))}
                                          </div>
                                          <p className="text-muted mb-0">{t('Basierend auf')} {reviews.length} {t('Bewertungen')}</p>
                                      </>
                                  ) : (
                                      <p className="text-muted">{t('Keine Bewertungen vorhanden')}</p>
                                  )}
                              </div>
                          </div>
                      </div>
                      <div className="col-lg-4 mb-3">
                          <div className="card border-0 shadow-sm h-100 mb-0">
                              <div className="px-4 py-3 border-bottom">
                                  <h5 className="fw-semibold mb-0">
                                      <i className="ti ti-chart-bar me-2 text-primary"></i>{t('Bewertungsverteilung')}
                                  </h5>
                              </div>
                              <div className="card-body">
                                  {reviews.length > 0 ? (
                                      [5,4,3,2,1].map(star => {
                                          const count = reviews.filter(r => r.rating === star).length;
                                          const pct = reviews.length > 0 ? Math.round((count / reviews.length) * 100) : 0;
                                          return (
                                              <div className="d-flex align-items-center mb-2" key={star}>
                                                  <span className="fw-semibold me-2" style={{width: '20px'}}>{star}</span>
                                                  <i className="ti ti-star-filled text-warning me-2"></i>
                                                  <div className="flex-grow-1 me-2">
                                                      <div className="progress" style={{height: '8px'}}>
                                                          <div className={'progress-bar bg-' + (star >= 4 ? 'success' : star === 3 ? 'warning' : 'danger')} role="progressbar" style={{width: pct + '%'}}></div>
                                                      </div>
                                                  </div>
                                                  <span className="text-muted fw-semibold" style={{minWidth: '65px', textAlign: 'right', whiteSpace: 'nowrap'}}>{count} ({pct}%)</span>
                                              </div>
                                          );
                                      })
                                  ) : (
                                      <p className="text-muted">{t('Keine Bewertungen vorhanden')}</p>
                                  )}
                              </div>
                          </div>
                      </div>
                      <div className="col-lg-4 mb-3">
                          <div className="card border-0 shadow-sm h-100 mb-0">
                              <div className="px-4 py-3 border-bottom">
                                  <h5 className="fw-semibold mb-0">
                                      <i className="ti ti-message-check me-2 text-success"></i>{t('Antwortrate')}
                                  </h5>
                              </div>
                              <div className="card-body text-center">
                                  {reviews.length > 0 ? (() => {
                                      const answered = reviews.filter(r => r.reviewReply).length;
                                      const unanswered = reviews.length - answered;
                                      const rate = Math.round((answered / reviews.length) * 100);
                                      return (
                                          <>
                                              <h1 className={'fw-bold mb-2 ' + (rate >= 80 ? 'text-success' : rate >= 50 ? 'text-warning' : 'text-danger')} style={{fontSize: '3.5rem'}}>
                                                  {rate}%
                                              </h1>
                                              <div className="progress mb-3" style={{height: '10px'}}>
                                                  <div className={'progress-bar bg-' + (rate >= 80 ? 'success' : rate >= 50 ? 'warning' : 'danger')} role="progressbar" style={{width: rate + '%'}}></div>
                                              </div>
                                              <div className="d-flex justify-content-between">
                                                  <div>
                                                      <span className="badge bg-light-success text-success me-1">{answered}</span>
                                                      <span className="text-muted fs-2">{t('beantwortet')}</span>
                                                  </div>
                                                  <div>
                                                      <span className="badge bg-light-danger text-danger me-1">{unanswered}</span>
                                                      <span className="text-muted fs-2">{t('offen')}</span>
                                                  </div>
                                              </div>
                                          </>
                                      );
                                  })() : (
                                      <p className="text-muted">{t('Keine Bewertungen vorhanden')}</p>
                                  )}
                              </div>
                          </div>
                      </div>
                  </div>


                    <div id="reportPage2">
                    {seoAudit && seoAudit.score !== undefined && (
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="card border-0 shadow-sm">
                                <div className="px-4 py-3 border-bottom">
                                    <h5 className="fw-semibold mb-0">
                                        <i className="ti ti-seo me-2 text-primary"></i>{t('SEO-Audit')}
                                    </h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-md-3 text-center mb-3">
                                            <h1 className={'fw-bold mb-1 ' + (seoAudit.score >= 80 ? 'text-success' : seoAudit.score >= 50 ? 'text-warning' : 'text-danger')} style={{fontSize: '3rem'}}>{seoAudit.score}%</h1>
                                            <p className="text-muted mb-0">{t('SEO Score')}</p>
                                        </div>
                                        {seoAudit.details && seoAudit.details.length > 0 && (
                                        <div className="col-md-9">
                                            {seoAudit.details.slice(0, 6).map((detail, i) => (
                                                <div key={'seo-' + i} className="d-flex align-items-center mb-2">
                                                    <i className={'ti me-2 ' + (detail.status === 'success' ? 'ti-circle-check text-success' : detail.status === 'warning' ? 'ti-alert-triangle text-warning' : 'ti-circle-x text-danger')}></i>
                                                    <span className="fs-3">{detail.title || detail.label}</span>
                                                </div>
                                            ))}
                                        </div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                    {competitors && competitors.length > 0 && (
                    <div className="row mb-3">
                        <div className="col-12">
                            <div className="card border-0 shadow-sm">
                                <div className="px-4 py-3 border-bottom">
                                    <h5 className="fw-semibold mb-0">
                                        <i className="ti ti-trophy me-2 text-warning"></i>{t('Wettbewerb')}
                                    </h5>
                                </div>
                                <div className="card-body p-0">
                                    <div className="table-responsive">
                                        <table className="table table-hover align-middle mb-0">
                                            <thead>
                                                <tr className="bg-light">
                                                    <th className="fw-semibold ps-4">{t('Wettbewerber')}</th>
                                                    <th className="fw-semibold text-center">{t('Bewertung')}</th>
                                                    <th className="fw-semibold text-center">{t('Bewertungen')}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {competitors.slice(0, 5).map((comp, idx) => (
                                                    <tr key={'comp-' + idx}>
                                                        <td className="ps-4">
                                                            <span className="fw-semibold">{comp.name || comp.title || t('Unbekannt')}</span>{comp.data?.formattedAddress && <><br/><span className="text-muted fs-2">{comp.data.formattedAddress}</span></>}
                                                        </td>
                                                        <td className="text-center">
                                                            <span className="text-warning fw-semibold"><i className="ti ti-star-filled me-1"></i>{comp.data?.rating ? comp.data.rating.toFixed(1) : '-'}</span>
                                                        </td>
                                                        <td className="text-center">
                                                            <span className="badge bg-light text-muted">{comp.data?.userRatingCount || '-'}</span>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    {competitorsAnalysis && competitorsAnalysis.summary && (
                                        <div className="p-4 border-top">
                                            <p className="text-muted mb-0 fs-3"><i className="ti ti-bulb me-1 text-warning"></i>{competitorsAnalysis.summary}</p>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    )}

                  <div className="row mb-3">
                      <div className="col-12">
                          <div id="businessesReviews" className="card border-0 shadow-sm">
                              <div className="px-4 py-3 border-bottom">
                                  <h5 className="fw-semibold mb-0">{t('Top Reviews')}</h5>
                              </div>
                              <div className="card-body p-0">
                                  <div className="table-responsive">
                                      <table className="table table-hover align-middle mb-0">
                                          <thead>
                                              <tr className="bg-light">
                                                  <th className="fw-semibold ps-4">{t('Review')}</th>
                                                  <th className="fw-semibold text-end pe-4" style={{width: '100px'}}>{t('Rating')}</th>
                                              </tr>
                                          </thead>
                                          <tbody>
                                              {reviews.filter((r, i) => i < 5).map((review, index) => (
                                                  <tr key={index}>
                                                      <td className="ps-4">
                                                          <div className="fw-semibold">{review.reviewer.displayName}</div>
                                                          <span className="text-muted fs-3">
                                                              "
                                                              {review.comment ? (
                                                                  StrHelper.filterGoogleTranslatedText(review.comment).split(' ').map((word, wordIndex, words) => (
                                                                      (((wordIndex < 10)?(word+' '):('')) + ((wordIndex === 10 && words.length > 10)?('...'):('')))
                                                                  ))
                                                              ) : (
                                                                  <span>{t('No text.')}</span>
                                                              )}
                                                              "
                                                          </span>
                                                      </td>
                                                      <td className="text-end pe-4">
                                                          <span className="fw-semibold text-warning">
                                                              <i className="ti ti-star-filled me-1"></i>{review.rating}.0
                                                          </span>
                                                      </td>
                                                  </tr>
                                              ))}
                                          </tbody>
                                      </table>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                    </div>
              </div>
          </>
      );
  }

  export default BusinessesInsights;